import React, {Fragment, useEffect, useState} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import PanelItemForm from "./panelitemForm";
import Tags from "../../form/Tags";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import ComponentConfig from "../../form/ComponentConfig";
import classNames from "classnames";
import PanelItemEditor from "../panelitemEditor";
import ModalEditor from "../ModalEditor";
import None from "../None";

const PanelItemList = (props) => {
    const [selectedPanelItem, setSelectedPanelItem] = useState(null);
    useEffect(() => {
        setSelectedPanelItem(null);
    },[props.values]);
    return <Fragment>
        <div className="col">
            <SelectorGrid
                data={props.values}
                componentConfig={props.componentConfig}
                name="items"
                columns={{
                    [props.panelitemComponentConfig.idfield]: {
                        header: "Kód",
                        width: 1,
                    },
                    "name": {
                        header: "Név",
                        width: 11,
                    },
                }}
                selection={selectedPanelItem}
                onSelectionChange={(selection) => setSelectedPanelItem(selection.value)}
            />
        </div>
        {selectedPanelItem && <PanelItemEditor
            gridid={"panelItemList"}
            list={None}
            editor={ModalEditor}
            selection={selectedPanelItem}
            values={selectedPanelItem}
        />}
    </Fragment>
}

const PanelItems = (props) => {
    return <ComponentConfig componentName="panelitem" componentConfigAs="panelitemComponentConfig">
        <PanelItemList {...props} />
    </ComponentConfig>
}

const PanelList = (props) => {
    const [selectedPanel, setSelectedPanel] = useState(null);
    return <div className="row">
        <div className="col">
            <SelectorGrid
                data={props.values}
                componentConfig={props.componentConfig}
                name="panels"
                columns={{
                    [props.panelComponentConfig.idfield]: {
                        header: "Kód",
                        width: 1,
                    },
                    "name": {
                        header: "Név",
                        width: 11,
                    },
                }}
                selection={selectedPanel}
                onSelectionChange={(selection) => setSelectedPanel(selection.value)}
                {...props.getFieldProps("panels")}
            />
        </div>
        {selectedPanel && <PanelItems
            componentConfig={props.panelComponentConfig}
            values={selectedPanel}
        />}
    </div>;
}

const Panels = (props) => {
    return <ComponentConfig componentName={props.componentConfig.fielddefs.panels.objects} componentConfigAs="panelComponentConfig">
        <PanelList {...props} />
    </ComponentConfig>;
}

class pageForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                   role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <TextInput name="pagetype" value={this.props.values.pagetype} label="Név"
                                   saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("pagetype")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Tags
                            name="title"
                            value={this.props.values.title}
                            label="Cím"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("title")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TextInput name="description" value={this.props.values.description} label="Leírás"
                                   saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("description")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TextInput name="image" value={this.props.values.image} label="Kép"
                                   saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("image")}/>
                    </div>
                </div>
                {this.props.values[this.props.componentConfig.idfield] && <div className="row form-row">
                    <div className="col-md-12">
                        <label className="control-label">Panelek</label>
                        <Panels {...this.props} />
                    </div>
                </div>}
            </form>
        );
    }
}

export default createForm(pageForm);
